// extracted by mini-css-extract-plugin
export default {"root":"Maintenance_root__CG-f6","link":"Maintenance_link__Bxw7d","content":"Maintenance_content__LjnV+","image":"Maintenance_image__uPD05"};